import styled from "styled-components";
import * as React from 'react';
import { Checkbox, Table } from "react-bootstrap";

export const Styles = styled.div`
    // padding: 1rem;

    .table {
        display: inline-block;
        border-spacing: 0;
        // border: 1px solid black;

        // .tr {
        //     :last-child {
        //     .td {
        //         border-bottom: 0;
        //     }
        // }

        .th,
        .td {
            margin: 0;
            padding: 0.5rem;
            text-align: center;
            // border-bottom: 1px solid black;
            // border-right: 1px solid black;

            :last-child {
                // border-right: 1px solid black;
            }
        }

        .td.actions {
            padding: 0.3rem;
        }

        .th.th-donor {
            background-color: #ddd;
            border-color: white white lightblue white;
            border-width: 1px 1px 0px 0px;
            border-style: solid;
            border-collapse: collapse;
            padding: 0.7rem 0.5rem;
            height: 32px;
            font-weight: 700;
            // display: flex !important;
            // justify-content: center;
        }

        .th.th-donor > span {
            // align-self: flex-end;
        }
    }

    .tr > .td {
        border-color: #ddd;
        border-width: 1px 1px 1px 0px;
        border-style: solid;
    }

    .tr:last-child .td {
        border-color: #ddd;
        border-width: 0px 1px 1px 0px;
        border-style: solid;
    }

    // .th-recipient {
    //     background-color: #ddd;
    //     border-color: white white #ddd white;
    //     border-width: 1px 1px 0px 0px;
    //     border-style: solid;
    // }

    .th-donor-main {
        background-color: #2D6CA2;
        color: #fff;
    }

    .th-actions {
        // border-bottom: 1px solid #ccc;
    }

    div[role='rowgroup'] > div.potential-donors-paired-donor {
        border-width: 1px 1px 0px 1px;
        border-color: #ccc #ccc #ccc #ccc;
        border-style: solid;
        // border-bottom-left-radius: 4px;
        // border-bottom-right-radius: 4px;
        //overflow: auto scroll !important;
    }

    div[role='rowgroup'] > div {
        border-width: 1px;
        border-color: #ccc #ccc #ccc #ccc;
        border-style: solid;
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
        overflow: auto scroll !important;
    }

    .tr.paired-donor {
        background-color: darkgreen;
        color: white;
        // position: sticky !important;
        // top: 0px !important
    }

    .btn-inverse {
        background-color: #555;
        background-image: linear-gradient(to bottom, #555 0%, #333 100%);
        background-repeat: repeat-x;
        border-color: #999;
        color: #FFF;
        font-weight: bold;
    }

    // .dropdown {
    //     position: inherit !important;
    // }

    .table > thead > tr > th.top {
        border-bottom-width: 1px !important;
    }
`;

const areEqual = (prevProps: any, nextProps: any) => prevProps.checked === nextProps.checked && prevProps.indeterminate === nextProps.indeterminate;

export const HeaderCheckbox = React.memo(
    styled(Checkbox)({
        fontSize: '1rem',
        margin: '-8px 0 -8px -15px',
        padding: '8px 9px',
        '& svg': {
            width: '24px',
            height: '24px',
        },
        '&:hover': {
            backgroundColor: 'transparent',
        },
    }),
    areEqual
)

export const RowCheckbox = React.memo(
    styled(Checkbox)({
        fontSize: '14px',
        margin: '-7px 0 -8px -7px',
        padding: '5px 9px',
        '&:hover': {
            backgroundColor: 'transparent',
        },
        '& svg': {
            width: 24,
            height: 24,
        },
    }),
    areEqual
)

export const GridWrapper = styled.div`
    width: 100%;
    height: 80vh;

    .action-menu {
        overflow: visible;
        border-bottom: none;
        // line-height: 33px;
        border-color: #ccc;
        display: flex;
        align-items: center;
    }

    .action-menu > .ag-react-container {
        width: 100%;
    }

    .action-menu.ag-cell-focus{
        border-top: 1px solid #ccc !important;
        border-right: 1px solid white !important;
        border-bottom: 1px solid white !important;
        border-left: 1px solid #ccc !important;
    }

    .ag-header {
        background-color: #133366;
        color: #FFF;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        font-family: Roboto;
        // font-weight: 700;
    }

    .ag-body-viewport {
        border-left: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
    }

    .ag-row {
        z-index: 0;
    }

    .ag-row.ag-row-hover {
        background-color: #eaf2fa;
    }

    .ag-row.ag-row-focus {
        z-index: 1;
    }

    .list-cell {
        border-bottom: none;
        text-align: center;
        // line-height: 33px;
        border-color: #ccc;
        // font-size: 12px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .list-header {
        display: flex;
        justify-content: center;
        //align-items: flex-end;
        //padding-bottom: 4px;
        color: #fff;
    }

    .list-header > .ag-cell-label-container > .ag-header-cell-label {
        display: flex;
        justify-content: center;
    }

    .ag-header-row > .ag-header-group-cell > .ag-header-group-cell-label {
        display: flex;
        justify-content: center;
    }

            .totals {
                font-weight: 600;
                background-color: #ddd;
            }

            .react-grid-Row:hover .react-grid-Cell, .react-grid-Row.row-context-menu .react-grid-Cell {
                background-color: lightgoldenrodyellow;
            }
        }

    .ag-icon.ag-icon-asc {
        color: white;
    }

    .ag-icon.ag-icon-desc {
        color: white;
    }

    .customHeaderLabel {
        margin-left: 5px;
        float: left;
        text-align: center;
    }

    .customSortDownLabel {
        // float: left;
        margin-left: 3px;
    }

    .customSortUpLabel {
        // float: left;
        margin-left: 3px;
    }

    .customSortRemoveLabel {
        float: left;
        font-size: 11px;
        margin-left: 3px;
    }

    .active {
        color: cornflowerblue;
    }
`;

export const TableWrapper = styled(Table)`
    & > thead > tr > th,
    & > tbody > tr > td {
        text-align: center;
    }

    & > thead > tr.top > th {
        border-bottom-width: 1px;
    }

    & > thead > tr.bottom > th {
        background-color: #ddd;
        border-color: white;
    }
`;